document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    const avatar = page.querySelector('[data-myaccount-avatar]');
    if (!avatar) return;

    const img = avatar.querySelector('img');
    if (!img) return;

    let input = null;
    function ensureInput() {
        if (input) return input;
        input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.style.display = 'none';
        page.appendChild(input);

        input.addEventListener('change', () => {
            const file = input.files && input.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (e) => {
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
            // Reset so picking the same file again still fires `change`.
            input.value = '';
        });

        return input;
    }

    avatar.addEventListener('click', (e) => {
        e.preventDefault();
        ensureInput().click();
    });
});
